import { createApp } from 'vue'
import StafetAddMoreDeltagerFlow from './StafetAddMoreDeltagerFlow'
import isObjectNotNullOrEmpty from 'foundation/js/isObjectNotNullOrEmpty'

const el = '.kb-component--stafet-add-more-deltager-flow'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetAddMoreDeltagerFlowDOM) => {
            const externalData = StafetAddMoreDeltagerFlowDOM.dataset.external
                ? JSON.parse(StafetAddMoreDeltagerFlowDOM.dataset.external)
                : null

            const props = {
                stafetId: externalData.stafetId ?? null,
                holdkode: isObjectNotNullOrEmpty(externalData.holdkode)
                    ? externalData.holdkode
                    : null,
                userData: isObjectNotNullOrEmpty(externalData.userData)
                    ? externalData.userData
                    : null,
                loggedIn: isObjectNotNullOrEmpty(externalData.userData),
                adultPrice: externalData.adultPrice,
                childPrice: externalData.childPrice
            }

            const component = createApp(StafetAddMoreDeltagerFlow, props).use(
                Store
            )
            component.mount(StafetAddMoreDeltagerFlowDOM)
        })
    }
}
